export enum ErrorMsgSettings {
     duration = 30000,
}

export const commonErrorMsg = 'Something went wrong while processing your request. Try again in a few minutes or contact System Support with the following transaction id - ';

export const commonErrorMsg2 = 'Internet Connection seems to be broken. Try again after your Internet Connection is restored. If the problem persists with a stable internet connection, contact the Systems Support.';

export const fileErrorMsg = 'We are unable to access the file. Ensure the file is available or contact System Support';
